import { render, staticRenderFns } from "./CodeEditorView.vue?vue&type=template&id=5bc16133&scoped=true&"
import script from "./CodeEditorView.vue?vue&type=script&lang=js&"
export * from "./CodeEditorView.vue?vue&type=script&lang=js&"
import style0 from "./CodeEditorView.vue?vue&type=style&index=0&id=5bc16133&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc16133",
  null
  
)

export default component.exports